import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import axios from 'axios';
import rootRuducer from './Redux/Reducers/CombindReducers';
import { SET_LOADING } from './Redux/Actions/ActionType';

var initialState = {};
var middleware = [thunk, logger];
var store = createStore(
	rootRuducer,
	initialState,
	compose(
		applyMiddleware(...middleware)
		// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	)
);
// const store = createStore(
// 	rootRuducer,
// 	{},
// 	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

// Global safety net: if any API request errors (timeout, network, server error),
// clear the loading flag so the UI never gets stuck on an infinite spinner.
// Backstops the many actions whose per-call .catch handlers are missing/commented.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    store.dispatch({ type: SET_LOADING, payload: false });
    return Promise.reject(error);
  }
);

export default store;
